import { Section } from '@alfa-retail-react/components';
import SuperEllipse from '@alfa-retail-react/components/super-ellipse';
import React from 'react';

import { ImageContent } from 'app/component/orderedPanelList/ImageItem';

import './OrderedPanelList.less';

export type TOrderedPanelListItem = {
    title: string;
    subTitle?: string;
    content: React.ReactNode;
};

interface IOrderedPanelList {
    items: TOrderedPanelListItem[];
}

/**
 * Компонент отображения панелей пронумерованным списком
 * @param items
 * @constructor
 */
export const OrderedPanelList = ({ items }: IOrderedPanelList) => {
    if (items.length === 0) {
        return null;
    }

    return (
        <div className="orderedPanelList">
            {items.map((item, index) => {
                return (
                    <div className="orderedPanelList__item" key={item.title}>
                        <div className="orderedPanelList__order-index">
                            <SuperEllipse border size={48}>
                                <span className="orderedPanelList__order-number">
                                    {index + 1}
                                </span>
                            </SuperEllipse>
                        </div>
                        <div className="orderedPanelListItem__content">
                            <Section
                                title={item.title}
                                subTitle={item.subTitle}
                            >
                                {item.content}
                            </Section>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

OrderedPanelList.ImageContent = ImageContent;
